import logger from 'utils/logger.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const L = logger('JSON'); // eslint-disable-line no-unused-vars

export const fromAnyToPrettyJson = (value) => {
  try {
    return JSON.stringify(value, null, 2);
  } catch (e) {
    L.warn('fromAnyToPrettyJson()', e, 'for value:', value);
  }
  return '';
};

export const fromAnyToUglyJson = (value) => {
  try {
    return JSON.stringify(value);
  } catch (e) {
    L.warn('fromAnyToUglyJson()', e, 'for value:', value);
    return '';
  }
};

export const fromAnyToJsonClone = (value) => {
  let json;

  try {
    json = JSON.stringify(value);
  } catch (e) {
    L.warn('fromAnyToJsonClone()', e, 'for value:', value);
    return void 1;
  }

  try {
    return JSON.parse(json);
  } catch (e) {
    L.warn('fromAnyToJsonClone()', e, 'for json:', json);
    return void 1;
  }
};

export const stringifyCustomJson = (options) => {
  const value = options?.value;
  const space = options?.pretty ? 2 : void 1;

  try {
    const replacer = options?.replacer;

    if (void 1 === replacer) return JSON.stringify(value, null, space);

    if (isNotFn(replacer)) {
      L.warn('fromAnyToUglyJsonPreservingNils()', 'Invalid replacer:', replacer, 'for value:', value);
      return JSON.stringify(value, null, space);
    }

    return JSON.stringify(value, replacer, space);
  } catch (e) {
    L.warn('fromAnyToUglyJsonPreservingNils()', e, 'for value:', value);
    return void 1;
  }
};
